/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppInfo
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary Application version (backend .app_version)
 */
export const getAppInfo = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<AppInfo>(
      {url: `/api/v1/app-info`, method: 'GET', signal
    },
      );
    }
  



export const getGetAppInfoQueryKey = () => {
    return [
    `/api/v1/app-info`
    ] as const;
    }

    
export const getGetAppInfoQueryOptions = <TData = Awaited<ReturnType<typeof getAppInfo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppInfo>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppInfo>>> = ({ signal }) => getAppInfo(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAppInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getAppInfo>>>
export type GetAppInfoQueryError = unknown


export function useGetAppInfo<TData = Awaited<ReturnType<typeof getAppInfo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppInfo>>,
          TError,
          Awaited<ReturnType<typeof getAppInfo>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppInfo<TData = Awaited<ReturnType<typeof getAppInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppInfo>>,
          TError,
          Awaited<ReturnType<typeof getAppInfo>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppInfo<TData = Awaited<ReturnType<typeof getAppInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppInfo>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Application version (backend .app_version)
 */

export function useGetAppInfo<TData = Awaited<ReturnType<typeof getAppInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppInfo>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




